import { DictionaryCountry } from '../models/dictionary-country';
import { DictionaryCountryResponse } from '../api/responses/dictionary-country.response';

export const dictionaryCountryFromResponse = (
  response: DictionaryCountryResponse,
) =>
  new DictionaryCountry({
    id: response.id,
    isoCode: response.isoCode,
    label: response.label,
  });
